import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SyncService } from '../../../services/sync.service';
import { AuthService } from '../../../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class ValidateSyncGuard  {
    private authService = inject(AuthService);
    private syncService = inject(SyncService);

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.syncService.isAppLocked) {
            this.authService.logout();
            return false;
        }

        return true;
    }
}
